export default __webpack_public_path__ + "static/media/beatbox.a48c1724.jpg";